import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Image, List } from '@mui/icons-material'
import OneModal from "../../../Components/OneModal/OneModal"
import { Button, Typography } from '@mui/material'
import OneTextArea from '../../../Components/OneTextArea/OneTextArea'
import OneSelect from '../../../Components/OneSelect/OneSelect'
import { OneSwitch } from '../../../Components/OneSwitch/OneSwitch'
import { useContext, useState } from 'react'
import CarrosselModal from '../../../Components/CarrosselModal/CarrosselModal'
import { WebSocketContext } from '../../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../../Providers/CondominiosContext/CondominiosContext'
import { showNotify } from '../../../Utils/Utils'
import { EventosContext } from '../../../Providers/EventosContext/EventosContext'
import { UserContext } from '../../../Providers/UserContext/UserContex'
import moment from 'moment'

const OcorrenciaModal = ({ openOcorrencia, setOpenOcorrencia, ocorrencia }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)
    const { updateObsIframe, eventoSelecionado } = useContext(EventosContext)
    const { user } = useContext(UserContext)

    const [data, setData] = useState({
        tratativa: ocorrencia.tratativa,
        status: ocorrencia.status,
        visivel_todos: ocorrencia.visivel_todos ? 1 : 0
    })

    const [openCarrossel, setOpenCarrossel] = useState(false)
    const [selectedImageIndexInicial, setSelectedImageIndexInicial] = useState(0)

    const handleOpenCarrossel = (index) => {
        setSelectedImageIndexInicial(index)
        setOpenCarrossel(true)
    }

    addRoute('atualizarOcorrencia', (msg) => {
        if (msg.data.status) {
            if (eventoSelecionado && eventoSelecionado.usuario_tratando && eventoSelecionado.usuario_tratando.id == user.id) {
                let tratativaObs = `tratou a ocorrência ${ocorrencia.titulo} em ${moment().format('DD/MM/YYYY HH:mm:ss')}\n\n${data.tratativa}`
                updateObsIframe(tratativaObs, tratativaObs)
            }
            sendWs('buscarOcorrencias', { filtros: { id_central: activeCond.id_central } })
            setOpenOcorrencia(false)
        } else {
            showNotify('Erro', msg.data.message)
        }
    })

    const handleSave = () => {
        if (data.tratativa == ocorrencia.tratativa && data.status == ocorrencia.status && data.visivel_todos == ocorrencia.visivel_todos) {
            setOpenOcorrencia(false)
        } else {
            data.tratativa += `\n\nTratado por: ${user.nome} em ${moment().format('DD/MM/YYYY HH:mm:ss')}`
            if (eventoSelecionado && eventoSelecionado.evento == 'OCAP') {
                const id = eventoSelecionado.id
                const observacao = data.tratativa
                const id_hashtag = eventoSelecionado.id_hashtag

                if (!id) {
                    return
                }
                sendWs('finalizarEvento', { id, observacao, id_hashtag, notificacoes: '' })
            }
            sendWs('atualizarOcorrencia', { filtros: { ...data, id_ocorrencia: ocorrencia.id, id_central: activeCond.id_central } })
            setOpenOcorrencia(false)
        }
    }

    return (
        <OneModal
            open={openOcorrencia}
            setOpen={setOpenOcorrencia}
            titleText="Ocorrência"
            TitleIcon={ List }
        >
            {openCarrossel &&
            <CarrosselModal
                openCarrossel={openCarrossel}
                setOpenCarrossel={setOpenCarrossel}
                images={ocorrencia.anexos}
                selectedImageIndexInicial={selectedImageIndexInicial}
            />
            }
            <Grid container direction={'column'} gap={1} xs={12} sx={{
                maxHeight: '400px',
                width: '693px'
            }}>
                <Typography>
                    Aberta por <b>{ocorrencia.autor} {ocorrencia.unidade1} {ocorrencia.unidade2}</b> em <b>{ocorrencia.data}</b>
                </Typography>
                <Grid item container xs={12}>
                    <Grid item xs={2}>
                        <Typography>Título:</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography sx={{ fontWeight: 'bold' }}>{ocorrencia.titulo}</Typography>
                    </Grid>
                </Grid>
                <Grid item container xs={12}>
                    <Grid item xs={2}>
                        <Typography>Texto:</Typography>
                    </Grid>
                    <Grid item xs={10} sx={{
                        maxHeight: '70px',
                        overflow: 'auto'
                    }}>
                        <Typography sx={{ fontWeight: 'bold' }}>{ocorrencia.mensagem}</Typography>
                    </Grid>
                </Grid>
                <Grid item container xs={12}>
                    <Grid item xs={2}>
                        Anexo:
                    </Grid>
                    <Grid item container direction={'row'} xs={10} spacing={1}>
                        {ocorrencia.anexos && ocorrencia.anexos.length > 0 && ocorrencia.anexos.map((anexo, index) => {
                            return (
                                <Grid item key={index}>
                                    <Image
                                        onClick={() => handleOpenCarrossel(index)}
                                        sx={{
                                            width: '35px',
                                            height: '35px',
                                            cursor: 'pointer'
                                        }} titleAccess={anexo.nomeArquivo} />
                                </Grid>
                            )
                        })
                        }
                    </Grid>
                </Grid>
                <Grid item container xs={12}>
                    <Grid item xs={2}>
                        <Typography>Tratativa: </Typography>
                    </Grid>
                    <Grid item direction={'row'} xs={10} >
                        <OneTextArea
                            defaultValue={ocorrencia.tratativa}
                            disabled={data.status === 2}
                            maxlength={500}
                            fontSize={'15px'}
                            newSx={{
                                width: '100%',
                                height: '100px',
                                padding: '5px'
                            }}
                            onChange={(e) => { setData({ ...data, tratativa: e.target.value }) }}
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={12}>
                    <Grid item xs={2}>
                        <Typography>Status:</Typography>
                    </Grid>
                    <Grid item xs={3} >
                        <OneSelect
                            options={[{ id: 0, nome: 'Aberto' }, { id: 1, nome: 'Em andamento' }, { id: 2, nome: 'Fechado' }]}
                            defaultValue={ocorrencia.status}
                            label={'nome'}
                            valor={'id'}
                            onChange={(e) => { setData({ ...data, status: e.target.value }) }}
                        />
                    </Grid>
                    <Grid item xs sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        height: '30px'
                    }}>
                        <OneSwitch
                            defaultChecked={ocorrencia.visivel_todos}
                            onChange={(e) => { setData({ ...data, visivel_todos: e.target.checked ? 1 : 0 }) }}
                        />
                        <Typography>Visível para todos do condomínio / empresa</Typography>
                    </Grid>
                </Grid>
                <Grid item container xs={12} justifyContent={'flex-end'}>
                    <Button
                        color={'one_primary'}
                        variant="contained"
                        disabled={!!(data.status === 2 && data.tratativa == '')}
                        onClick={() => data.status === 2 && data.tratativa == '' ? null : handleSave()}
                        sx={{ width: '148px', height: '30px' }}
                    >
                            Salvar
                    </Button>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default OcorrenciaModal
